import { render, staticRenderFns } from "./PPCForm.vue?vue&type=template&id=71ecd684&scoped=true"
import script from "./PPCForm.vue?vue&type=script&lang=js"
export * from "./PPCForm.vue?vue&type=script&lang=js"
import style0 from "./PPCForm.vue?vue&type=style&index=0&id=71ecd684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecd684",
  null
  
)

export default component.exports